import Empty from '../empty/Empty';
const FriendsGroup = ({friends}) => {

      if(friends.data || friends.length === 0){
            return (
                  <div className="friend_col">
                        <Empty text="Oops! Not Friends Added."/>
                  </div>
            )
      }

      return (
            <div className="friend_col">
                  {
                        friends?.map((item, index) => (
                              <div className="friend_card" key={index}>
                                    <img src={item.avatar} alt={item.name} />
                                    <div className="friend_data">
                                          <h3>{item.name}</h3>
                                          <p>{item.description}</p>
                                          <a href={item.me} target="_blank" rel="noreferrer">xat.me</a>
                                    </div>
                              </div>
                        ))
                  }
            </div>
      )
}

export default FriendsGroup;